import React, { useState, useEffect, useMemo } from "react";
import { Button } from "@mui/material";
import { Box, Typography } from "@material-ui/core";
import Link from "@material-ui/core/Link";
import PrintIcon from "@material-ui/icons/Print";
import CircularProgress from "@material-ui/core/CircularProgress";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import AlertTitle from "@material-ui/lab/AlertTitle";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import AmendmentType from "./AmendmentType";
import AmendmentLetter from "./AmendmentLetter";
import { getDefaultAmendmentType } from "./amendmentUtil";
import { DocsDataAPI } from "../../API/DocsDataAPI";
import ChangeTypeTable from "./ChangeTypeTable";
import NmefSpinner from '../../NmefSpinner';

import { ApplicationDataAPI } from "../../API/ApplicationDataAPI";

function Alert(props) {
	return <MuiAlert elevation={6} variant="filled" {...props} />;
}

export const Other = "Other";

const Amendments = ({ app, isReadOnly, onParentModalClose }) => {
	const yourSincerely = window?.authProvider?.account?.name ?? "";
	const appStatus = app?.status;
	const contractNumber = app?.contract_number;
	const applicantName = app?.applicant_name;
	const street = app?.address;
	const city = app?.city;
	const state = app?.state;
	const zipCode = app?.zip_code;

	const [openDialog, setOpenDialog] = useState(false);
	const [loading, setLoading] = useState(false);
	const [amendmentTypeOptions, setAmendmentTypeOptions] = useState([]);
	const [changeTypeOptions, setChangeTypeOptions] = useState([]);
	const [otherTypeText, setOtherTypeText] = useState("");
	const [amendmentType, setAmendmentType] = useState(() => {
		return getDefaultAmendmentType(appStatus);
	});
	const [alertModal, setAlertModal] = React.useState({
		isSubmitting: false,
		open: false,
		message: "",
		status: "",
	});

	const [finalDealStructure, setFinalDealStructure] = useState("");
	const [mostExpensiveAsset, setMostExpensiveAsset] = useState("");

	const [latestAmendment, setLatestAmendment] = useState();
	const [latestDealStructure, setLatestDealStructure] = useState("");

	const [isSubmitting, setIsSubmitting] = useState(false);
	const [disableAmendment, setDisableAmendment] = useState(false);

	// Change Type table
	const [rows, setRows] = useState([]);
	const [openDMDialog, setOpenDMDialog] = useState(false);

	const [isSaveDisabled, setIsSaveDisabled] = useState(true);

	const [remainingChars, setRemainingChars] = useState(0);
	const [primaryGuar, setPrimaryGuar] = useState("");

	const maxLength = 250;
	let totalLength = 0;

	let disableCount = 0;
	let valueCount = 0;

	const updateRows = (newRows) => {
		setRows(newRows);
	};

	useEffect(() => {
		const newRows = rows.map((currentRow) => {
			return { ...currentRow, changedTo: "", currentValue: "" }
		});
		setRows(newRows);
		if (amendmentType === latestAmendment?.type && !latestAmendment?.date_time_processed)
			setOtherTypeText(latestAmendment?.changes);
		else
			setOtherTypeText("");
	}, [amendmentType]);

	const selectedChangeTypes = useMemo(() => {
		const newRows = rows
			.filter((row) => {
				valueCount =
					valueCount + row.currentValue.trim().length + row.changedTo.trim().length;

				if (
					(row.currentValue.trim().length > 0) &
					(row.changedTo.trim().length <= 0) ||
					(row.changedTo.trim().length > 0) & (row.currentValue.trim().length <= 0)
				) {
					disableCount = disableCount + 1;
				}

				if (disableCount > 0 || valueCount === 0) {
					setIsSaveDisabled(true);
				} else {
					setIsSaveDisabled(false);
				}

				if (
					row.currentValue.trim().length !== 0 &&
					row.changedTo.trim().length !== 0
				) {
					return true;
				}

				return false;
			})
			.map((row) => {
				return `${row.changeType} change From: ${row.currentValue} To Become: ${row.changedTo}`;
			});

		if (
			otherTypeText !== undefined ||
			otherTypeText !== "" ||
			otherTypeText !== null
		) {
			if (otherTypeText.trim().length > 0) {
				newRows.push(otherTypeText);
			}
		}

		return newRows;
	}, [rows, otherTypeText]);

	useEffect(() => {
		//for loop to grab length of all array
		totalLength = 0;
		for (let i = 0; i < selectedChangeTypes.length; i++) {
			totalLength = totalLength + selectedChangeTypes[i].length;
		}

		setRemainingChars(maxLength - totalLength);

		if (maxLength - totalLength < 0 || disableCount > 0) {
			setIsSaveDisabled(true);
		}
	}, [selectedChangeTypes]);

	// Grab deal structure of application
	useEffect(() => {
		(async () => {
			await DocsDataAPI.fetchApplicationById(app.id, app.broker_id, app.locked_by_email)
				.then((resp) => { })
				.catch((error) => console.log("error", error));

			let guarantorList = await ApplicationDataAPI.fetchApplicationGuarantorsById(
				app?.id,
				app?.broker_id,
				app.locked_by_email
			);
			//get primary signor guarantor
			for (var i = 0; i < guarantorList.length; i++) {
				if (guarantorList[i].guarantor.require_verbal_DNA == true) {
					setPrimaryGuar(
						guarantorList[i].guarantor.first_name +
						" " +
						guarantorList[i].guarantor.last_name
					);
					break;
				}
			}
		})();
	}, []);

	// Grab deal structure of application
	useEffect(() => {
		(async () => {
			await DocsDataAPI.fetchApplicationDealsById(app.id, app.broker_id, app.locked_by_email)
				.then((resp) => {
					grabDealStructure(resp);
				})
				.catch((error) => console.log("error", error));
		})();
	}, [finalDealStructure]);

	useEffect(() => {
		(async () => {
			await DocsDataAPI.fetchApplicationAssetsById(app.id, app.broker_id, app.locked_by_email)
				.then((resp) => {
					grabHighestAsset(resp);
				})
				.catch((error) => console.log("error", error));
		})();
	}, [mostExpensiveAsset]);

	function grabDealStructure(resp) {
		for (let i = 0; i < resp.length; i++) {
			if (resp[i].selected_for_submitted_deal == true) {
				setLatestDealStructure(resp[i]);
				setFinalDealStructure(resp[i].final_deal_structure);
				break;
			}
		}
	}

	function grabHighestAsset(resp) {
		let appAssets = [];
		for (let i = 0; i < resp.length; i++) {
			appAssets.push(resp[i]);
		}

		appAssets.sort((a, b) => (a.price < b.price ? 1 : -1));

		setMostExpensiveAsset(appAssets[0].booking_description);
	}

	function grabHighestAppVersion(resp) {
		let amendmentVersions = [...resp];

		amendmentVersions.sort((a, b) => (a.version < b.version ? 1 : -1));
		//setting the other text type only if amendment is not generated
		if (!amendmentVersions[0].date_time_processed) {
			setOtherTypeText(amendmentVersions[0].changes);
		} else {
			resetValues();
		}

		return amendmentVersions[0];
	}

	// Amendment type options
	useEffect(() => {
		(async () => {
			await DocsDataAPI.getAmendmentTypes()
				.then((resp) => {
					setAmendmentTypeOptions(resp);
				})
				.catch((error) => console.log("error", error));
		})();
	}, []);

	// Change type options
	useEffect(() => {
		(async () => {
			await DocsDataAPI.getAmendmentsChanges()
				.then((resp) => {
					setChangeTypeOptions(resp);
					setRows(
						resp
							.filter((changeType) => changeType !== Other)
							.map((changeType) => {
								return {
									changeType: changeType,
									currentValue: "",
									changedTo: "",
								};
							})
					);
				})
				.catch((error) => console.log("error", error));
		})();
	}, []);

	// Get - Amendments
	useEffect(() => {
		if (!isSubmitting) getSavedAmendment();
	}, [app?.id, isSubmitting]);

	const getSavedAmendment = async () => {
		setLoading(true);
		resetValues();
		await DocsDataAPI.getAmendments(app?.id)
			.then((resp) => {
				if (resp.length) {
					setLatestAmendment(grabHighestAppVersion(resp));
				}
				if (resp.length === 0) {
					setDisableAmendment(true);
				} else {
					setDisableAmendment(false);
				}
			})
			.catch((error) => console.log("error", error));
		setLoading(false);
	}

	const handleAmendmentChange = (event) => {
		setAmendmentType(event.target.value);
	};

	const updateOtherTypeText = (text) => {
		setOtherTypeText(text);
	};

	const handleSave = async () => {
		setIsSubmitting(true);
		const parsedChanges = selectedChangeTypes.join("\n");
		if (latestAmendment?.id && !latestAmendment?.date_time_processed) {
			const payload = {
				id: latestAmendment?.id,
				version: latestAmendment.version,
				type: amendmentType,
				contract_number: contractNumber,
				changes: parsedChanges,
				applicant_name: applicantName,
				app_name: app?.id,
				address_city: city,
				address_state: state,
				address_street: street,
				address_zip: zipCode,
			};
			await DocsDataAPI.putAmendments([payload]);
		}
		else if (latestAmendment?.id && latestAmendment?.date_time_processed) {
			const payload = {
				version: latestAmendment.version + 1,
				type: amendmentType,
				contract_number: contractNumber,
				changes: parsedChanges,
				applicant_name: applicantName,
				app_name: app?.id,
				address_city: city,
				address_state: state,
				address_street: street,
				address_zip: zipCode,
			};
			await DocsDataAPI.postAmendments([payload]);
		}
		else {
			const payload = {
				app_name: app?.id,
				address_city: city,
				address_state: state,
				address_street: street,
				address_zip: zipCode,
				applicant_name: applicantName,
				changes: parsedChanges,
				contract_number: contractNumber,
				type: amendmentType,
				version: 1,
			};
			await DocsDataAPI.postAmendments([payload]);
		}
		setIsSubmitting(false);
	};

	const moveToDM = async () => {
		setIsSubmitting(true);

		await DocsDataAPI.moveToDmApplication(app.broker_id, app.locked_by_email, {
			id: app.id,
			broker_id: app.broker_id,
			status: "Dealmaker",
			is_locked:false,
			selected_for_proposal:false,
			selected_for_submitted_deal:false,
			disable_lock:true,
		});

		await DocsDataAPI.moveToDmCreditAnalysis(app.broker_id, app.locked_by_email, {
			application_id: app.id,
			id: latestDealStructure.credit_analysis_id,
			is_locked: false,
		});

		await DocsDataAPI.moveToDmDealStructure(app.broker_id, app.locked_by_email, {
			application_id: app.id,
			id: latestDealStructure.id,
			credit_analysis_id: latestDealStructure.credit_analysis_id,
			selected_for_submitted_deal: false,
			disable_lock: true,
			is_locked:false,
            selected_for_proposal:false,
		});

		handleSave();

		setIsSubmitting(false);

		window.location.reload();
	};

	const generateAmendment = async () => {
		setAlertModal({
			...alertModal,
			isSubmitting: true,
		});

		await DocsDataAPI.generateAmendments(
			app?.id,
			latestAmendment.version ?? 1,
			app?.locked_by_email
		);

		setOpenDialog(true);
	};

	const resetValues = () => {
		// setAmendmentType(getDefaultAmendmentType(appStatus));
		setRows((currentRows) => {
			return currentRows.map((row) => {
				return { ...row, currentValue: "", changedTo: "" };
			});
		});
		// setOtherTypeText("");
	};

	const handleClose = (event, reason) => {
		if (reason === "clickaway") {
			return;
		}

		setAlertModal({
			isSubmitting: false,
			open: false,
			message: "",
			status: "",
		});
	};

	const handleDialogClose = () => {
		setOpenDialog(false);
		onParentModalClose();
	};

	return (
		<>
			<Snackbar
				open={alertModal.open}
				autoHideDuration={6000}
				anchorOrigin={{ vertical: "top", horizontal: "center" }}
				onClose={handleClose}>
				<Alert onClose={handleClose} severity={alertModal.status}>
					<AlertTitle>
						{alertModal.status === "error" ? "Error" : "Success"}
					</AlertTitle>
					{alertModal.message}
				</Alert>
			</Snackbar>
			<Dialog
				open={openDialog}
				onClose={handleDialogClose}
				aria-labelledby="alert-dialog-title"
				aria-describedby="alert-dialog-description">
				<DialogContent>
					<DialogContentText id="alert-dialog-description">
						Generate Template request is sent. Please check Documents page. Requires
						anywhere between 10 seconds to 5 mins for the document to be generated.
					</DialogContentText>
				</DialogContent>
				<DialogActions>
					<Button onClick={handleDialogClose} color="primary" autoFocus>
						Ok
					</Button>
				</DialogActions>
			</Dialog>
			<Dialog
				open={openDMDialog}
				onClose={() => setOpenDMDialog(false)}
				aria-labelledby="alert-dialog-title"
				aria-describedby="alert-dialog-description">
				<DialogTitle id="alert-dialog-title">
					Do you want this deal to be moved back to Deal Maker?
				</DialogTitle>
				<DialogContent>
					<DialogContentText id="alert-dialog-description"></DialogContentText>
				</DialogContent>
				<DialogActions>
					<Button
						onClick={() => {
							setOpenDMDialog(false);
							moveToDM();
						}}
						color="primary">
						Yes
					</Button>
					<Button onClick={() => setOpenDMDialog(false)} color="secondary" autoFocus>
						No
					</Button>
				</DialogActions>
			</Dialog>
			{loading ?
				<NmefSpinner />
				: <Box sx={{ padding: "20px", display: "flex" }}>
					<Box sx={{ flex: 1 }}>
						<AmendmentType
							amendmentTypeOptions={amendmentTypeOptions}
							amendmentType={amendmentType}
							handleAmendmentChange={handleAmendmentChange}
						/>
						{/* <ChangeType
						changeTypeOptions={changeTypeOptions}
						selectedChangeTypes={selectedChangeTypes}
						updateSelectedChangeType={updateSelectedChangeType}
						otherTypeText={otherTypeText}
						updateOtherTypeText={updateOtherTypeText}
					/> */}
						<ChangeTypeTable
							rows={rows}
							updateRows={updateRows}
							changeTypeOptions={changeTypeOptions}
							otherTypeText={otherTypeText}
							amendmentType={amendmentType}
							updateOtherTypeText={updateOtherTypeText}
							isReadOnly={isReadOnly}
						/>
						{amendmentType !== "New Docs" && <Box style={{ display: "flex", justifyContent: "end" }}>
							<p style={{ color: remainingChars < 0 ? "red" : "black" }}>
								{remainingChars} characters left
							</p>
						</Box>}

						<Box sx={{ marginTop: "16px", display: "flex", justifyContent: "center" }}>
							<Link
								style={{ marginRight: "16px", color: "#194F77", cursor: "pointer" }}
								onClick={resetValues}>
								Discard Changes
							</Link>

							{amendmentType !== "New Docs" ? (
								<>
									<Button
										disabled={isSaveDisabled}
										variant="contained"
										color="primary"
										size="small"
										onClick={handleSave}
										style={{
											cursor: "pointer",
											borderRadius: "4px",
											textTransform: "capitalize",
										}}
										startIcon={
											isSubmitting && <CircularProgress size={20} color="#ccc" />
										}>
										Save Changes
									</Button>
									<Button
										disabled={isReadOnly || disableAmendment}
										variant="contained"
										color="primary"
										size="small"
										onClick={() => generateAmendment()}
										style={{
											cursor: "pointer",
											borderRadius: "4px",
											textTransform: "capitalize",
											marginLeft: "10px",
										}}
										startIcon={
											alertModal.isSubmitting && <CircularProgress size={20} color="#ccc" />
										}>
										Generate Amendment
									</Button>
								</>
							) : (
								<Button
									variant="contained"
									color="primary"
									size="small"
									onClick={() => setOpenDMDialog(true)}
									style={{
										cursor: "pointer",
										borderRadius: "4px",
										textTransform: "capitalize",
										marginLeft: "10px",
									}}
									startIcon={isSubmitting && <CircularProgress size={20} color="#ccc" />}>
									Move to Deal Maker
								</Button>
							)}
						</Box>
					</Box>
					<Box ml={3} sx={{ flex: 1 }}>
						<AmendmentLetter
							contract={contractNumber}
							applicant={applicantName}
							street={street}
							city={city}
							state={state}
							zip={zipCode}
							yourSincerely={amendmentType === "Clarification Letter" ? yourSincerely : applicantName}
							selectedChangeTypes={selectedChangeTypes}
							otherTypeText={otherTypeText}
							amendmentType={amendmentType}
							recordType={app?.record_type}
							dealStructure={finalDealStructure}
							mostExpensiveAsset={mostExpensiveAsset}
							primaryGuar={primaryGuar}
							businessEntity={app?.business_entity_type}
							isCorpOnlyDeal={app?.Is_Corporate_Only_Deal}
						/>
					</Box>
				</Box>}
		</>
	);
};

export default Amendments;
